var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDropdownUser1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_949_1994",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 49
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24,
    fill: "white",
    stroke: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_949_1994)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    rx: 24.5,
    fill: "#EFFAFC",
    stroke: "#BDDFE5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 7.71875C21.5938 7.71875 12.3125 9.25566 12.3125 21.1968C12.3125 31.2924 13.6875 40.0312 13.6875 40.0312H33.9688C33.9688 40.0312 35.6875 31.2924 35.6875 21.1968C35.6875 9.25566 26.4062 7.71875 24 7.71875Z",
    fill: "url(#paint0_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4375 36.25L27.0938 31.4375H20.9062L20.5625 36.25C10.9715 36.25 10.9375 49.3125 10.9375 49.3125H37.0625C37.0625 49.3125 37.0285 36.25 27.4375 36.25Z",
    fill: "url(#paint1_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4373 36.25L27.0935 31.4375H20.906L20.8799 31.8012L28.4685 39.2571L27.4373 36.25Z",
    fill: "url(#paint2_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6249 21.2774C17.0588 22.7668 16.5565 24.214 15.5036 24.5093C14.4507 24.8049 13.2455 23.8369 12.8117 22.3475C12.3779 20.858 12.8801 19.4108 13.933 19.1155C14.9863 18.8202 16.1915 19.7879 16.6249 21.2774Z",
    fill: "url(#paint3_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3747 21.2774C30.9409 22.7668 31.4431 24.214 32.496 24.5093C33.5489 24.8049 34.7541 23.8369 35.1879 22.3475C35.6217 20.858 35.1195 19.4108 34.0666 19.1155C33.0134 18.8202 31.8082 19.7879 31.3747 21.2774Z",
    fill: "url(#paint4_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5476 21.5049C16.757 22.245 16.416 22.9824 15.7855 23.1525C15.1551 23.3227 14.4741 22.8604 14.2648 22.1206C14.0554 21.3805 14.3964 20.6432 15.0269 20.473C15.6573 20.3029 16.3379 20.7649 16.5476 21.5049Z",
    fill: "url(#paint5_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4523 21.5049C31.2429 22.245 31.5839 22.9824 32.2144 23.1525C32.8448 23.3224 33.5258 22.8604 33.7351 22.1206C33.9445 21.3805 33.6035 20.6432 32.973 20.473C32.3426 20.3029 31.662 20.7649 31.4523 21.5049Z",
    fill: "url(#paint6_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 32.8125C20.2813 32.8125 15.0625 27.4156 15.0625 22.5V17.6875C15.0625 12.7719 19.0844 8.75 24 8.75C28.9156 8.75 32.9375 12.7719 32.9375 17.6875V22.5C32.9375 27.4156 27.7091 32.8125 24 32.8125Z",
    fill: "url(#paint7_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6529 22.5H20.4718C20.1435 22.5 19.875 22.2315 19.875 21.9029V21.0343C19.875 20.706 20.1435 20.4375 20.4721 20.4375H20.6532C20.9815 20.4375 21.25 20.706 21.25 21.0346V21.9032C21.25 22.2315 20.9815 22.5 20.6529 22.5Z",
    fill: "#51251F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5279 22.5H27.3468C27.0185 22.5 26.75 22.2315 26.75 21.9029V21.0343C26.75 20.706 27.0185 20.4375 27.3471 20.4375H27.5282C27.8565 20.4375 28.125 20.706 28.125 21.0346V21.9032C28.125 22.2315 27.8565 22.5 27.5279 22.5Z",
    fill: "#51251F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5315 19.4911C19.3933 19.4911 19.263 19.4072 19.2104 19.2704C19.1424 19.093 19.231 18.8943 19.4081 18.8263C20.0746 18.5702 21.1148 18.5723 21.7277 18.8304C21.9027 18.904 21.9848 19.1058 21.9109 19.2807C21.8374 19.4557 21.6359 19.5382 21.4606 19.4639C21.0048 19.2718 20.1612 19.2735 19.6552 19.4681C19.6143 19.4839 19.5727 19.4911 19.5315 19.4911Z",
    fill: "#7A5954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.4065 19.4911C26.2683 19.4911 26.138 19.4072 26.0854 19.2704C26.0174 19.093 26.106 18.8943 26.2831 18.8263C26.9496 18.5702 27.9898 18.5723 28.6027 18.8304C28.7777 18.904 28.8598 19.1058 28.7859 19.2807C28.712 19.4557 28.5113 19.5382 28.3356 19.4639C27.8798 19.2718 27.0362 19.2735 26.5302 19.4681C26.4893 19.4839 26.4477 19.4911 26.4065 19.4911Z",
    fill: "#7A5954"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 25.25C23.8103 25.25 23.6562 25.096 23.6562 24.9062V22.8438C23.6562 22.654 23.8103 22.5 24 22.5C24.1897 22.5 24.3438 22.654 24.3438 22.8438V24.9062C24.3438 25.096 24.1897 25.25 24 25.25Z",
    fill: "url(#paint8_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 26.9688C24 26.9688 23.131 26.0324 21.9375 27.3125C21.9375 27.3125 22.3242 28.6875 24 28.6875C25.6758 28.6875 26.0625 27.3125 26.0625 27.3125C24.869 26.0324 24 26.9688 24 26.9688Z",
    fill: "#FFA8A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 7.71875C21.5938 7.71875 12.3125 9.25566 12.3125 21.1968C12.3125 21.5609 12.3149 21.9228 12.3183 22.2831C18.4777 21.0257 26.6304 16.2695 29.1562 14.5938C30.5966 18.7019 32.6457 21.2518 35.5232 21.9369L35.6834 21.9827C35.6858 21.7218 35.6875 21.4598 35.6875 21.1968C35.6875 9.25566 26.4062 7.71875 24 7.71875Z",
    fill: "url(#paint9_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4375 36.25L25.375 39.3438L24 41.75L22.625 39.3438L20.5625 36.25C10.9715 36.25 10.9375 49.3125 10.9375 49.3125H37.0625C37.0625 49.3125 37.0285 36.25 27.4375 36.25Z",
    fill: "#6BD5E2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1562 36.5938L18.1501 36.5615C18.1501 36.5615 18.092 36.5777 18.026 36.5969C16.9071 36.9252 15.9648 37.4683 15.1711 38.1507L15.1708 38.1521C15.1691 38.1538 15.167 38.1551 15.1653 38.1565C14.9989 38.2995 14.8394 38.4484 14.6861 38.6031C10.9547 42.3633 10.9375 49.3126 10.9375 49.3126H15.8875H20.5625L18.1562 36.5938Z",
    fill: "url(#paint10_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1501 36.5615C18.1501 36.5615 18.092 36.5777 18.026 36.5969C16.9071 36.9252 15.9648 37.4683 15.1711 38.1507L14.0312 44.1563L16.7812 45.5313L15.0625 47.2501L15.8875 49.3126H20.5625L18.1501 36.5615Z",
    fill: "url(#paint11_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8438 36.5938L29.8499 36.5615C29.8499 36.5615 29.908 36.5777 29.974 36.5969C31.0929 36.9252 32.0352 37.4683 32.8289 38.1507L32.8292 38.1521C32.8309 38.1538 32.833 38.1551 32.8347 38.1565C33.0011 38.2995 33.1606 38.4484 33.3139 38.6031C37.0453 42.3633 37.0625 49.3126 37.0625 49.3126H32.1125H27.4375L29.8438 36.5938Z",
    fill: "url(#paint12_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8499 36.5615C29.8499 36.5615 29.908 36.5777 29.974 36.5969C31.0929 36.9252 32.0352 37.4683 32.8289 38.1507L33.9688 44.1563L31.2188 45.5313L32.9375 47.2501L32.1125 49.3126H27.4375L29.8499 36.5615Z",
    fill: "url(#paint13_linear_949_1994)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5625 33.5L22.625 39.3438L17.125 41.75L18.1562 36.25L20.5625 33.5Z",
    fill: "#ADE1E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4375 33.5L25.375 39.3438L30.875 41.75L29.8438 36.25L27.4375 33.5Z",
    fill: "#ADE1E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_949_1994",
    x1: 24,
    y1: 3.56109,
    x2: 24,
    y2: 40.0313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A87063"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A563E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_949_1994",
    x1: 24,
    y1: 31.4375,
    x2: 24,
    y2: 95.9941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    stopColor: "#F8DBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8222,
    stopColor: "#F6D3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CABD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_949_1994",
    x1: 22.4072,
    y1: 29.8996,
    x2: 27.7913,
    y2: 35.7612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEAE9A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3851,
    stopColor: "#EFB19D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6587,
    stopColor: "#F1B9A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8972,
    stopColor: "#F5C7B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7D0BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_949_1994",
    x1: 12.656,
    y1: 21.8126,
    x2: 16.781,
    y2: 21.8126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    stopColor: "#F8DBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8222,
    stopColor: "#F6D3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CABD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_949_1994",
    x1: 35.3437,
    y1: 21.8126,
    x2: 31.2187,
    y2: 21.8126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    stopColor: "#F8DBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8222,
    stopColor: "#F6D3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CABD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_949_1994",
    x1: 14.2356,
    y1: 22.1387,
    x2: 16.5151,
    y2: 21.5097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BEAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_949_1994",
    x1: 33.7807,
    y1: 21.9372,
    x2: 31.5015,
    y2: 21.3083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1BEAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_949_1994",
    x1: 16.4186,
    y1: 12.6447,
    x2: 31.5793,
    y2: 27.8058,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9DDD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5137,
    stopColor: "#F8DBCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8222,
    stopColor: "#F6D3C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4CABD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_949_1994",
    x1: 24,
    y1: 22.5,
    x2: 24,
    y2: 25.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7D0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEAE9A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_949_1994",
    x1: 15.8982,
    y1: 9.21475,
    x2: 28.1958,
    y2: 23.7485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AC766A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93634D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_949_1994",
    x1: 15.75,
    y1: 36.5615,
    x2: 15.75,
    y2: 49.3126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198DC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12639B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_949_1994",
    x1: 17.2969,
    y1: 36.5615,
    x2: 17.2969,
    y2: 49.3126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3779A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_949_1994",
    x1: 32.25,
    y1: 36.5615,
    x2: 32.25,
    y2: 49.3126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#198DC4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#12639B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_949_1994",
    x1: 30.7031,
    y1: 36.5615,
    x2: 30.7031,
    y2: 49.3126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3779A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174F71"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownUser1);
export default __webpack_public_path__ + "static/media/dropdown-user-1.70058bb037727bf51a8249f64ee381a8.svg";
export { ForwardRef as ReactComponent };